export interface ColumnMeta {
  field: string;
  title: string;
}

export const exportCSVManual = (
  data: any[],
  columns: ColumnMeta[],
  filename = "export.csv"
) => {
  const csvHeader = columns.map((col) => `"${col.title}"`).join(",");
  const csvRows = data.map((row) =>
    columns.map((col) => `"${row[col.field] ?? ""}"`).join(",")
  );

  const csvContent = [csvHeader, ...csvRows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  const safeTitle = filename.replace(/\s+/g, "-").toLowerCase();

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", safeTitle);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
